"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Stores = require("../store/Service");
var ModalRegisterServiceComponent_1 = require("./ModalRegisterServiceComponent");
var ModalConfirmDeleteServiceComponent_1 = require("./ModalConfirmDeleteServiceComponent");
var Service = /** @class */ (function (_super) {
    __extends(Service, _super);
    function Service(props) {
        var _this = _super.call(this, props) || this;
        _this.afterOpenModalDelete = function () {
            _this.setState({ isOpenModalDelete: false });
        };
        _this.state = {
            pageLoad: true,
            isOpenModalDelete: false,
            serviceSelected: {
                service_id: "",
                service_name: "",
                created_by: "",
                created_on: ""
            }
        };
        _this.BindData = _this.BindData.bind(_this);
        return _this;
    }
    Service.prototype.componentDidMount = function () {
        this.ensureDataFetched();
    };
    Service.prototype.ensureDataFetched = function () {
        this.setState({ pageLoad: true });
        this.props.requestFunction(this.state.pageLoad);
        this.setState({ pageLoad: false });
    };
    Service.prototype.BindData = function () {
        this.ensureDataFetched();
    };
    Service.prototype.render = function () {
        var _a = this.state, isOpenModalDelete = _a.isOpenModalDelete, serviceSelected = _a.serviceSelected;
        return (React.createElement("div", { style: { paddingLeft: 'unset' } },
            React.createElement(ModalRegisterServiceComponent_1.default, { BindData: this.BindData.bind(this) }),
            React.createElement("hr", null),
            React.createElement("h4", { className: "mb-3", style: { fontWeight: 'bold' } }, "Service"),
            this.props.isLoading && this.renderService(),
            React.createElement(ModalConfirmDeleteServiceComponent_1.default, { isOpenModalDelete: isOpenModalDelete, serviceSelected: serviceSelected, afterOpenModalDelete: this.afterOpenModalDelete.bind(this) })));
    };
    Service.prototype.renderService = function () {
        var _this = this;
        //console.log(this.props.response)
        return (React.createElement(React.Fragment, null,
            React.createElement("table", { className: 'table table-bordered' },
                React.createElement("thead", null,
                    React.createElement("tr", { style: { background: "rgba(9, 132, 227, 1)", color: "#fff", fontSize: '10pt' } },
                        React.createElement("th", null, "Service ID"),
                        React.createElement("th", null, "Service Name"),
                        React.createElement("th", null, "Created By"),
                        React.createElement("th", null, "Created On"),
                        React.createElement("th", null))),
                React.createElement("tbody", null, (this.props.isLoading && this.props.response.result_list != undefined) && this.props.response.result_list.map(function (item) {
                    return React.createElement("tr", { key: item.service_id, className: 'table-tbody table-tr-active' },
                        React.createElement("td", null, item.service_id),
                        React.createElement("td", null, item.service_name),
                        React.createElement("td", null, item.created_by),
                        React.createElement("td", null),
                        React.createElement("td", null,
                            React.createElement("div", { className: "d-flex justify-content-center" },
                                React.createElement("button", { className: "btn btn-danger", onClick: function () { return _this.setState({ isOpenModalDelete: true, serviceSelected: item }); } },
                                    React.createElement("i", { className: "fas fa-ban" })))));
                })))));
    };
    return Service;
}(React.Component));
exports.default = react_redux_1.connect(function (state) { return state.service; }, Stores.actionCreators)(Service);
//<td>{moment(item.created_on).format('DD/MMM/YYYY, HH:mm')}</td>
//# sourceMappingURL=Service.js.map